<template>
  <div class="p-4">
    <icon-view
      class="ml-3 text-size"
      :has-border="false"
      icon="fas fa-info-circle color-orange"
      icon-size="1rem"
      title="Información Adicional"
      variant="custom-icon-view"
    />
    <div class="row mt-4">
      <div class="col-12 col-md-2">
        <CustomInput
          v-model="value.phone"
          class="read-only px-3"
          label="Teléfono:"
          :disabled="isDisabled"
        />
      </div>

      <div class="col-12 col-md-2">
        <ValidationProvider v-slot="{ errors }" rules="email">
          <CustomInput
            v-model="value.email"
            :error="errors[0]"
            :custom-error-msg="'El correo electrónico no es válido.'"
            label="Correo Electrónico:"
            class="read-only px-3"
            :disabled="isDisabled"
          />
        </ValidationProvider>
      </div>

      <div class="col-12 col-md-2">
        <CustomInput
          v-model="value.startDate"
          label="Fecha desde:"
          class="read-only px-3"
          disabled
        />
      </div>
      <div class="col-12 col-md-4">
        <CustomInput
          v-model="value.endDate"
          label="Fecha hasta:"
          class="read-only px-3"
          disabled
        />
      </div>

      <div v-if="!isDisabled" class="col-12 col-md-2 my-auto text-right">
        <br />
        <div class="mt-2">
          <ActionButton
            text="Guardar"
            variant="success"
            i="fas fa-save"
            @click="save"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "CustomInput";
import ActionButton from "ActionButton";
import formDataUtil from "@/utils/formDataUtil";
import {
  saveServiceAssistantInformation,
  updateServiceAssistantInformation
} from "@/modules/human-resources/api.js";
import alert from "@/mixin/alert.mixin";
import IconView from "icon-view";
const initialModel = () => ({
  contractNumber: null,
  phone: null,
  email: null,
  startDate: null,
  endDate: null
});

export default {
  name: "AdditionalInformation",
  mixins: [alert],
  components: { CustomInput, ActionButton, IconView },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      model: { ...initialModel() }
    };
  },
  methods: {
    async save() {
      const formData = this.createFormData(this.model.id);

      if (this.model.id) {
        await this.update(formData);
      } else {
        await this.create(formData);
      }
    },
    async update(dto) {
      await updateServiceAssistantInformation(dto);

      this.ShowToast(
        "Confirmación",
        "El asistente de servicio ha sido guardado exitosamente.",
        "success"
      );
    },
    async create(dto) {
      const data = await saveServiceAssistantInformation(dto);

      this.model.id = data.id;

      this.ShowToast(
        "Confirmación",
        "El asistente de servicio ha sido guardado exitosamente.",
        "success"
      );
    },
    createFormData(id) {
      const formData = new FormData();

      if (id) {
        formDataUtil.build(formData, id, "id");
      }

      formDataUtil.build(formData, this.value.contractNumber, "contractNumber");
      formDataUtil.build(formData, this.value.phone, "phone");
      formDataUtil.build(formData, this.value.email, "email");

      return formData;
    }
  }
};
</script>
<style scoped>
.text-size {
  font-size: 14px !important;
}
</style>
